/**
 * SweepTicker — friendly "N places across M regions — explore them all"
 * chip mounted on the homepage. Live-refreshes every 60 s.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Globe2 } from "lucide-react";
import { http } from "@/lib/api";

export default function SweepTicker() {
  const [t, setT] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => {
      http.get("/geo/explore/india")
        .then((r) => alive && setT(r.data?.totals || null))
        .catch(() => {});
    };
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!t || !t.locations) return null;

  return (
    <Link
      to="/explore/india"
      className="inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs sm:text-sm hover:brightness-95 transition"
      style={{
        borderColor: "#F59E0B55",
        background: "linear-gradient(90deg, #FEF3C7 0%, #FDE68A 100%)",
        color: "#7C2D12",
      }}
      data-testid="sweep-ticker"
    >
      <Globe2 className="w-3.5 h-3.5" />
      <span className="tabular-nums font-medium">{t.locations.toLocaleString()}</span> places
      <span className="opacity-60">·</span>
      <span className="tabular-nums font-medium">{t.pois.toLocaleString()}</span> POIs
      <span className="opacity-60">·</span>
      <span className="tabular-nums font-medium">{t.regions}</span> regions
      <span className="hidden sm:inline opacity-70">— explore them all</span>
    </Link>
  );
}
